import { render, staticRenderFns } from "./MatrixWeightFactTableColumn.vue?vue&type=template&id=7c7e9ad8"
import script from "./MatrixWeightFactTableColumn.vue?vue&type=script&lang=js"
export * from "./MatrixWeightFactTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports